// extracted by mini-css-extract-plugin
export default {"subtitleContainer":"cancel-alert-modal_subtitleContainer__Ah+q9"};